export default [
    {
        path: '/pages/affiliate/affiliateWithdrawalManage',
        name: '/pages/affiliate/affiliateWithdrawalManage',
        meta: { title: '分销提现' },
        component: () => import('@/views/affiliate/affiliateWithdrawalManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateVisitManage',
        name: '/pages/affiliate/affiliateVisitManage',
        meta: { title: '分销访问记录' },
        component: () => import('@/views/affiliate/affiliateVisitManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateUserManage',
        name: '/pages/affiliate/affiliateUserManage',
        meta: { title: '分销人员' },
        component: () => import('@/views/affiliate/affiliateUserManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateUserDetail',
        name: '/pages/affiliate/affiliateUserDetail',
        component: () => import('@/views/affiliate/affiliateUserDetail.vue')
    },
    {
        path: '/pages/affiliate/affiliateUserAuditManage',
        name: '/pages/affiliate/affiliateUserAuditManage',
        meta: { title: '分销申请' },
        component: () => import('@/views/affiliate/affiliateUserAuditManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateRuleManage',
        name: '/pages/affiliate/affiliateRuleManage',
        meta: { title: '分销设置' },
        component: () => import('@/views/affiliate/affiliateRuleManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateRelationManage',
        name: '/pages/affiliate/affiliateRelationManage',
        component: () => import('@/views/affiliate/affiliateRelationManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateProductManage',
        name: '/pages/affiliate/affiliateProductManage',
        meta: { title: '分销商品' },
        component: () => import('@/views/affiliate/affiliateProductManage.vue')
    },
    {
        path: '/pages/affiliate/affiliateCommissionManage',
        name: '/pages/affiliate/affiliateCommissionManage',
        meta: { title: '分销订单' },
        component: () => import('@/views/affiliate/affiliateCommissionManage.vue')
    }
]
